import React from "react";
import {  Query, Loading} from "../../components";
import TestDescription from "../../components/LiveTestDescription";
import TestStart from "./TestStart";
import { getLiveTest, submitTest } from "../../lib/api";

const Test = ({
  match: {
    params: { tid, qid }
  }
}) => {
  return (
    <>
      <Query query={() => getLiveTest(tid)}>
        {({ loading, data }) => {
          if (loading) {
            return <Loading />;
          }
          return !qid ? (
            <TestDescription {...data} {...{ tid }} />
          ) : (
            <TestStart {...data} {...{ tid, qid }} submitTest={submitTest} />
          );
        }}
      </Query>
    </>
  );
};

export default Test;
